module.exports = __webpack_public_path__ + "static/snelwandelen-342db732b12ec295747139498a005e6b.svg";